
const zblkNext = [1,1,2,0,1,1];
const sblkNext = [1,2,1,1,2,0,1];
const lblkNext = [0,1,2,0,1,2,0,1,1];
const jblkNext = [0,1,1,2,0,1,2,0,1];
const oblkNext = [1,1,2,1,1];
const iblkNext = [0,1,2,0,1,2,0,1,2,0,1,2];
const tblkNext = [0,1,2,1,1,1];

const zblk = [  // mirrored
    [1,1,2,0,1,1],
    [0,1,2,1,1,2,1],
    [1,1,2,0,1,1],
    [0,1,2,1,1,2,1],
    ];
const sblk = [  // mirrored
    [0,1,1,2,1,1,0],
    [1,2,1,1,2,0,1],
    [0,1,1,2,1,1,0],
    [1,2,1,1,2,0,1],
    ];
const lblk = [ 
    [0,0,1,2,1,1,1],
    [0,1,2,0,1,2,0,1,1],
    [2,1,1,1,2,1],
    [1,1,2,0,1,2,0,1],
    ];
const jblk = [ 
    [1,2,1,1,1],
    [0,1,1,2,0,1,2,0,1],
    [2,1,1,1,2,0,0,1],
    [0,1,2,0,1,2,1,1],
    ];
const oblk = [ 
    [1,1,2,1,1],
    [1,1,2,1,1],
    [1,1,2,1,1],
    [1,1,2,1,1],
    ];
const iblk = [  // mirrored i think its better
    [2,1,1,1,1],
    [0,0,1,2,0,0,1,2,0,0,1,2,0,0,1,2],
    [2,1,1,1,1],
    [0,0,1,2,0,0,1,2,0,0,1,2,0,0,1,2],
    ];
const tblk = [ 
    [0,1,2,1,1,1],
    [0,1,2,0,1,1,2,0,1],
    [2,1,1,1,2,0,1],
    [0,1,2,1,1,2,0,1],
    ];






  const blkTypes = [zblk, sblk, tblk, oblk, lblk, jblk, iblk];
  const nextBlkTypes = [zblkNext, sblkNext, tblkNext, oblkNext, lblkNext, jblkNext, iblkNext];

function getRandomBlk() {

    let random = Math.floor(Math.random()*blkTypes.length);

    return blkTypes[random];
  }

function getRandomBagOfBlks() {

    let MAX_ATTEMPTS = 1000;

    let shuffledArray = [];
    let arrayPreShuffle = [];
    let i = 0;

    for (i = 0; i < blkTypes.length; i++) {
        arrayPreShuffle[i] = blkTypes[i];
    }
    let min = 0;
    let max = 0;
    let numbersToShuffle = blkTypes.length;

    while (numbersToShuffle != 0 || MAX_ATTEMPTS < 0) {
  
        // get random int
        min = Math.ceil(0);
        max = Math.floor(arrayPreShuffle.length);
        // get random int
        i = Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
      
        // check that value hasn't been used yet..
        if (arrayPreShuffle[i] != null) {
            shuffledArray.push(i);
            arrayPreShuffle[i] = null;
            numbersToShuffle--;
        }

      MAX_ATTEMPTS--;
  
  
    }
    
    return shuffledArray

}


                        //test1      /test2    /test4   /test4
const kickDataCommon = [[-1, 0,   -1,  1,   0, -2,   -1, -2 ], // 0>>1
                        [ 1, 0,    1, -1,   0,  2,    1,  2 ], // 1>>0
                        [ 1, 0,    1, -1,   1,  2,    1,  2 ], // 1>>2
                        [-1, 0,   -1,  1,   0, -2,   -1, -2 ], // 2>>1
                        [ 1, 0,    1,  1,   1, -2,    1, -2 ], // 2>>3
                        [-1, 0,   -1, -1,   0,  2,   -1,  2 ], // 3>>2
                        [-1, 0,   -1, -1,   1,  2,   -1,  2 ], // 3>>0
                        [ 1, 0,    1,  1,   0, -2,    1, -2 ], // 0>>3
                    ]

                                            //test1      /test2    /test4   /test4
const kickDataSZ = [
                                            [-1, 0,   -1,  1,   0, -2,   -1, -2 ], // 0>>1
                                            [-1, 0,   -1, -1,   0,  2,   -1,  2 ], // 1>>0
                                            [-1, 0,   -1, -1,   -1,  2,  -1,  2 ], // 1>>2
                                            [-1, 0,   -1,  1,   0, -2,   -1, -2 ], // 2>>1
                                            [ 1, 0,    1,  1,   1, -2,    1, -2 ], // 2>>3
                                            [-1, 0,   -1, -1,   0,  2,   -1,  2 ], // 3>>2
                                            [-1, 0,   -1, -1,   1,  2,   -1,  2 ], // 3>>0
                                            [ 1, 0,    1,  1,   0, -2,    1, -2 ], // 0>>3
]



/*
                        //test1    /test2    /test4   /test4
const kickDataI =      [[-2, 0,    1,  0,  -2, -1,    1,  2 ], // 0>>1
                        [ 2, 0,   -1,  0,   2,  1,   -1, -2 ], // 1>>0
                        [-1, 0,    2,  0,  -1,  2,    2, -1 ], // 1>>2
                        [ 1, 0,   -2,  0,   1, -2,   -2,  2 ], // 2>>1
                        [ 2, 0,   -1,  0,   2,  1,   -1, -2 ], // 2>>3
                        [-2, 0,    1,  0,  -2, -1,    1,  2 ], // 3>>2
                        [ 1, 0,   -2,  0,   1, -2,   -2,  1 ], // 3>>0
                        [-1, 0,    2,  0,  -1,  2,    2, -1 ], // 0>>3
                    ]
 */

                        //test1    /test2    /test4   /test4
const kickDataI =      [
                        [-2, 0,    1,  0,  -2, -1,    1,  2 ], // 0>>1
                        [ 2, 0,   -1,  0,   2,  1,   -1, -2 ], // 1>>0
                        [-1, 0,    2,  0,  -1,  2,    2, -1 ], // 1>>2
                        [ 1, 0,   -2,  0,   1, -2,   -2,  2 ], // 2>>1
                        [-2, 0,    1,  0,  -2, -1,    1,  2 ], // 2>>3
                        [ 2, 0,   -1,  0,   2,  1,   -1, -2 ], // 3>>2
                        [-1, 0,    2,  0,  -1,  2,    2, -1 ], // 3>>0
                        [ 1, 0,   -2,  0,   1, -2,   -2,  2 ], // 0>>3
                    ]

  //  0      1    2     3     4     5     6
  // [zblk, sblk, tblk, oblk, lblk, jblk, iblk];

function getKickData(tetrominoType, cRot, rotV, testNumber  ) {

    let resultArray = [];

    let rotIndex = 0;
    let testIndex = testNumber * 2;



    if       (cRot == 0 && rotV == 1)   rotIndex = 0;
    else if  (cRot == 1 && rotV == -1)  rotIndex = 1;
    else if  (cRot == 1 && rotV == 1)   rotIndex = 2;
    else if  (cRot == 2 && rotV == -1)  rotIndex = 3;
    else if  (cRot == 2 && rotV == 1)   rotIndex = 4;
    else if  (cRot == 3 && rotV == -1)  rotIndex = 5;
    else if  (cRot == 3 && rotV == 1)   rotIndex = 6;
    else if  (cRot == 0 && rotV == -1)  rotIndex = 7;


    if (tetrominoType == 6 ) {
        resultArray.push(kickDataI[rotIndex][testIndex]);
        resultArray.push(kickDataI[rotIndex][testIndex + 1]);        
    }    else if (tetrominoType == 0 || tetrominoType == 1)  {
        resultArray.push(kickDataSZ[rotIndex][testIndex]);
        resultArray.push(kickDataSZ[rotIndex][testIndex + 1]);  
    } else{ 
        resultArray.push(kickDataCommon[rotIndex][testIndex]);
        resultArray.push(kickDataCommon[rotIndex][testIndex + 1]);    

    }



    return resultArray;
}



export { blkTypes, zblk, sblk, tblk, oblk, lblk, jblk, iblk, nextBlkTypes, zblkNext, sblkNext, tblkNext, oblkNext, lblkNext, jblkNext, iblkNext, getRandomBlk, getRandomBagOfBlks, getKickData, kickDataCommon, kickDataI, kickDataSZ  }




